import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-column',
  templateUrl: './no-column.component.html',
  styleUrls: ['./no-column.component.css']
})
export class NoColumnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
